export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_08.eeefe003.jpg";